import React, { useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { Radio, Space } from 'antd'
import useOutsideClick from '../../../../hooks/useOutsideClick'

export function SourceFilter({ source, setSource }) {
  const [openSourceFilter, setOpenSourceFilter] = useState(false)
  const sourceFilterRef = useRef(null)

  useOutsideClick(sourceFilterRef, () => {
    if (sourceFilterRef) {
      setOpenSourceFilter(false)
    }
  })

  const handleSourceChange = (e) => {
    if (typeof setSource === 'function') {
      setSource(e.target.value)
    }
  }

  return (
    <div className="relative" ref={sourceFilterRef}>
      <button className="flex items-center gap-[8px] px-[12px]" onClick={() => setOpenSourceFilter(!openSourceFilter)}>
        <div style={{ width: '20px', height: '20px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <svg width="18" height="18" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M8.23189 4L18.5006 14.2687L15.9331 16.8362C15.2638 17.5323 14.4623 18.088 13.5757 18.4706C12.689 18.8533 11.7349 19.0552 10.7693 19.0647C9.80359 19.0742 8.84574 18.891 7.95173 18.5258C7.05773 18.1606 6.24554 17.6208 5.56268 16.9379C4.87982 16.2551 4.34 15.4429 3.97482 14.5489C3.60964 13.6549 3.42642 12.697 3.4359 11.7314C3.44537 10.7657 3.64734 9.81161 4.02998 8.92494C4.41263 8.03828 4.96827 7.23683 5.6644 6.56749L8.23189 4Z"
              stroke="#41434B"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M1 21.5L5.37499 17.125"
              stroke="#41434B"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M14.75 1.5L10.375 5.87499"
              stroke="#41434B"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M21 7.75L16.625 12.125"
              stroke="#41434B"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
        <p className="text-[#41434B] text-[16px] font-medium font-['Manrope']">
          {source === 'gong' || source === 'Gong'
            ? 'Gong'
            : source === 'upload'
              ? 'Upload'
              : source === 'calendar'
                ? 'Calendar'
                : source === 'live'
                  ? 'Live Recording'
                  : source === 'google' || source === 'Google'
                    ? 'Google Meet'
                    : source === 'zoom' || source === 'Zoom'
                      ? 'Zoom'
                      : source === 'teams' || source === 'Teams'
                        ? 'Teams'
                        : source === 'slack' || source === 'Slack'
                          ? 'Slack'
                          : source === 'other'
                            ? 'Other'
                            : 'Any Source'}
        </p>
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clipPath="url(#clip0_3983_17643)">
            <circle cx="9.88218" cy="9.82065" r="7.27964" fill="#EBEBEB" />
            <path
              d="M12.3082 9.01367L9.88162 11.4402L7.45508 9.01367"
              stroke="#40424A"
              strokeWidth="1.3866"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_3983_17643">
              <rect width="19.4124" height="19.4124" fill="white" transform="translate(0.175781 0.115234)" />
            </clipPath>
          </defs>
        </svg>
      </button>
      {openSourceFilter && (
        <div className="absolute w-auto left-[-1px] top-[40px] p-2 bg-white shadow rounded-md border border-[#E5E5E5] z-50">
          <Radio.Group onChange={handleSourceChange} value={source}>
            <Space direction="vertical">
              <Radio value={''}>Any Source</Radio>
              <Radio value={'gong'}>Gong</Radio>
              <Radio value={'zoom'}>Zoom</Radio>
              <Radio value={'google'}>Google Meet</Radio>
              <Radio value={'teams'}>Teams</Radio>
              <Radio value={'slack'}>Slack</Radio>
              <Radio value={'upload'}>Upload</Radio>
            </Space>
          </Radio.Group>
        </div>
      )}
    </div>
  )
}

SourceFilter.propTypes = {
  source: PropTypes.string,
  setSource: PropTypes.func,
}
